import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { compose, setDisplayName } from 'react-recompose';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';
import { withEnabledFeatures } from '../../utils/features';
import { HUBS_SUBSCRIPTION, MATCHING_SUBSCRIPTION, PHEM_SUBSCRIPTIONS } from '../../containers/Authorization/constants';

const PremiumHemSubscriptionComponent = ({ inactive = false, enabledFeatures, heAccount, children }) => {
  const subscriptions = enabledFeatures.includes('CAMINO_PROVISIONS_PREMIUM_HEM') ? PHEM_SUBSCRIPTIONS : /* istanbul ignore next */ [MATCHING_SUBSCRIPTION, HUBS_SUBSCRIPTION];
  const hasSubscription = heAccount && [].concat(subscriptions).some((sub) => includes(heAccount.activeSubscriptions, sub));
  if (hasSubscription !== inactive) return children;
  return null;
};

const PremiumHemSubscription = compose(
  setDisplayName('PremiumHemSubscription'),
  withHEAccountSubscriptions,
  withEnabledFeatures,
)(PremiumHemSubscriptionComponent);

PremiumHemSubscription.propTypes = {
  inactive: PropTypes.bool,
  children: PropTypes.node,
};

export default PremiumHemSubscription;
